import { Component, Input } from '@angular/core';
import {Router} from "@angular/router";

@Component({
    selector: 'app-landingmenu',
    templateUrl: './landingmenu.component.html',
    styleUrls: ['./landingmenu.component.scss'],
    standalone: false
})
export class LandingmenuComponent {
  @Input() pageName: string = "";
  hamburgerMenuDisplayed = false

  constructor(private router: Router) { }

  ngAfterViewInit() {
    setTimeout(() => {
    this.listenToMenuClick();
    },1000)
  }

  ngOnDestroy() {
    window.removeEventListener('click', this.listenToMenuClick.bind(this));
  }

  listenToMenuClick() {
      const hamburger = document.getElementById("hamburger");
      const menu = document.getElementById("menu");
      if (hamburger && menu) {
      hamburger.addEventListener("click", () => {
        this.hamburgerMenuDisplayed = !this.hamburgerMenuDisplayed
        menu.classList.toggle("active"); // after clickinng on hamburger, add active class to menu
      });
    }
  }

  navigateTo(path: string) {
    this.router.navigate([path])
  }

}
